import { type ColumnType, type Selectable } from 'kysely'
import { z } from 'zod'

import { cableId, type CableId } from './Cable.js'
import {
  sensorCalibrationId,
  type SensorCalibrationId,
} from './SensorCalibration.js'
import { userId, type UserId } from './User.js'

/** Represents the view public.sensor_calibration_with_position_view_ */
export default interface SensorCalibrationWithPositionViewTable {
  /** Database type: pg_catalog.uuid */
  id: ColumnType<SensorCalibrationId, never, never>

  /** Database type: pg_catalog.text */
  sensorId: ColumnType<string, never, never>

  /** Database type: pg_catalog.int4 */
  cableId: ColumnType<CableId, never, never>

  /** Database type: pg_catalog.int4 */
  calibrationId: ColumnType<number | null, never, never>

  /** Database type: pg_catalog.int4 */
  sensorNumber: ColumnType<number, never, never>

  /** Database type: pg_catalog.numeric */
  calibrationOffset: ColumnType<number | null, never, never>

  /** Database type: pg_catalog.int4 */
  positionFromSectionStartMm: ColumnType<number, never, never>

  /** Database type: pg_catalog.int4 */
  spacingToNextSensorMm: ColumnType<number, never, never>

  /** Database type: pg_catalog.text */
  component: ColumnType<string, never, never>

  /** Database type: pg_catalog.int4 */
  sectionOrder: ColumnType<number, never, never>

  /** Database type: pg_catalog.timestamptz */
  calibrationDate: ColumnType<Date, never, never>

  /** Database type: pg_catalog.text */
  calibrationOperator: ColumnType<string | null, never, never>

  /** Database type: pg_catalog.text */
  calibrationNotes: ColumnType<string | null, never, never>

  /** Database type: pg_catalog.int4 */
  cableSerial: ColumnType<number | null, never, never>

  /** Database type: pg_catalog.int4 */
  cableSensorCount: ColumnType<number, never, never>

  /** Database type: pg_catalog.timestamptz */
  createdAt: ColumnType<Date | null, never, never>

  /** Database type: pg_catalog.uuid */
  createdBy: ColumnType<UserId | null, never, never>

  /** Database type: pg_catalog.timestamptz */
  updatedAt: ColumnType<Date | null, never, never>

  /** Database type: pg_catalog.uuid */
  updatedBy: ColumnType<UserId | null, never, never>
}

export type SensorCalibrationWithPositionView =
  Selectable<SensorCalibrationWithPositionViewTable>

export const sensorCalibrationWithPositionView = z.object({
  id: sensorCalibrationId,
  sensorId: z.string(),
  cableId: cableId,
  calibrationId: z.number().nullable().optional(),
  sensorNumber: z.number(),
  calibrationOffset: z.number().nullable().optional(),
  positionFromSectionStartMm: z.number(),
  spacingToNextSensorMm: z.number(),
  component: z.string(),
  sectionOrder: z.number(),
  calibrationDate: z.coerce.date(),
  calibrationOperator: z.string().nullable().optional(),
  calibrationNotes: z.string().nullable().optional(),
  cableSerial: z.number().nullable().optional(),
  cableSensorCount: z.number(),
  createdAt: z.coerce.date().nullable().optional(),
  createdBy: userId.nullable().optional(),
  updatedAt: z.coerce.date().nullable().optional(),
  updatedBy: userId.nullable().optional(),
}) as unknown as z.Schema<SensorCalibrationWithPositionView>
